module.exports = __webpack_public_path__ + "media/images/freshdesk-293b5b1002989a5ae198cbed1083ca48.svg";